export const CAROUSEL_TABS_CSS_CLASS_NAME = 'carousel-tabs';
export const CAROUSEL_TABS_TAB_CSS_CLASS_NAME = `${CAROUSEL_TABS_CSS_CLASS_NAME}__tab`;
